/** Export. */
export class ExportExcel {
  constructor(data) {
    this.name = data.name;
    this.url = data.url;
  }
}
